import _ from 'lodash';


export const getTranslations = (path = '') => {
  let _TRANSLATIONS_ = global.LOCALIZATION || {};

  if(path === ''){
    return _TRANSLATIONS_;
  }

  _TRANSLATIONS_ = _.get(_TRANSLATIONS_, path) || {};

  //console.log(_TRANSLATIONS_)

  return _TRANSLATIONS_;
};



// WEBPACK FOOTER //
// ./common/utils/index.js